import { inject, observer } from 'mobx-react';
import React from 'react';
import { Heading, Icon, OptionCard, OptionCardContent, Text, OptionCardGroup } from 'telia-front-react';
import MobileBusinessStore, { NumberCount } from '../../stores/MobileBusinessStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Package } from '../MobileBusinessInterfaces';

export interface NumberCountSelectorProps {
  mobileBusinessStore?: MobileBusinessStore;
  selectedPackage: Package;
}

const NumberCountSelector = (props: NumberCountSelectorProps) => {
  const translate = React.useContext(TranslationsContext).translate;
  const {
    mobileBusinessStore: { numberCount, selectNumberCount },
    selectedPackage
  } = props;

  const packageName = `${selectedPackage.capacity} ${
    selectedPackage.capacity && typeof selectedPackage.capacity !== 'string' ? translate(`mobileBusiness.capacityUnit.${selectedPackage.capacityUnit}`) : ''
  } ${translate('mobileBusiness.multiNumber.package')}`;

  return (
    <OptionCardGroup
      inputType="radio"
      name="number-count"
      label="number-count"
      hideLabel={true}
      value={numberCount}
      onChange={(value) => selectNumberCount(value as NumberCount)}
      gridColumn={{
        width: ['xs-12', 'sm-6', 'md-5']
      }}
    >
      <OptionCard id="number-count-single" value={NumberCount.SINGLE} inputType="radio" labelText={translate('mobileBusiness.multiNumber.single')}>
        <OptionCardContent>
          <Text className="text-center">
            <Icon modifiers="#mobile" size="xxl" />
            <Heading level={3} className="h5 text-bold">
              {translate('mobileBusiness.multiNumber.single')}
            </Heading>
            <p className="text-small">{packageName}</p>
          </Text>
        </OptionCardContent>
      </OptionCard>
      <OptionCard id="number-count-multiple" value={NumberCount.MULTIPLE} inputType="radio" labelText={translate('mobileBusiness.multiNumber.multi')}>
        <OptionCardContent>
          <Text className="text-center">
            <Icon modifiers="#devices-mobile" size="xxl" />
            <Heading level={3} className="h5 text-bold">
              {translate('mobileBusiness.multiNumber.multi')}
            </Heading>
            <p className="text-small">{packageName}</p>
          </Text>
        </OptionCardContent>
      </OptionCard>
    </OptionCardGroup>
  );
};

export default inject('mobileBusinessStore')(observer(NumberCountSelector));
